<div
	class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary {{ sectionclass }}"
	style="position: relative"
>
	<app-loader [showLoader]="showLoad"></app-loader>
	<div
		class="c-portlet__header o-stack o-stack--center o-stack--splitted u-border-bottom u-px-small u-py-mini c-portlet-gap u-border-bottom"
		style="position: relative"
	>
		<div class="o-stack__cell">
			<h5>{{ sectiontitle }}</h5>
		</div>
	</div>
	<div class="c-portlet__content">
		<div
			class="screenshotscontent"
			*ngIf="!isR102 && !isR103"
			[ngClass]="screenshotsMatrix.length == 0 ? 'no-screenshots' : ''"
		>
			<div *ngIf="screenshotsMatrix.length > 0 && hasData; else noScreenshotsBlock" class="screens-outer-div">
				<div class="card-row screen-div" *ngFor="let screenshots of screenshotsMatrix">
					<div class="card" *ngFor="let screenshot of screenshots">
						<div class="screen-inline">
							<div
								class="image"
								(click)="previewScreenshot(screenshot.imageURL)"
								[ngStyle]="{ 'background-image': 'url(' + screenshot.imageURL + ')' }"
							></div>
						</div>
						<div class="screen-inline info-container">
							<div class="title">{{ screenshot.url }}</div>
							<div class="sub-title" (click)="previewScreenshot(screenshot.imageURL)">{{ screenshot.date }}</div>
						</div>
					</div>
				</div>
			</div>
			<ng-template #noScreenshotsBlock>
				<div class="no-screenshots-data" *ngIf="!isR6Enabled || !hasData">
					{{ nodatamessage }}
				</div>
				<div *ngIf="isR6Enabled" class="no-data-scrennshots">
					<div class="no-data-text">No Data Available</div>
				</div>
			</ng-template>
		</div>

		<div class="screenshotscontent" *ngIf="isR102 || isR103">
			<div *ngIf="screenShotsData.length > 0 && hasData; else noScreenshotsBlock" class="screens-outer-div">
				<div class="card-row screen-div">
					<div
						class="card"
						*ngFor="let screenshot of screenShotsData | paginate : { itemsPerPage: 10, currentPage: p2 }; index as i"
					>
						<div class="screen-inline">
							<div
								class="image"
								(click)="previewScreenshot(screenshot.imageURL)"
								[ngStyle]="{ 'background-image': 'url(' + screenshot.imageURL + ')' }"
							></div>
						</div>
						<div class="screen-inline info-container">
							<div class="title">{{ screenshot.url }}</div>
							<div class="sub-title" (click)="previewScreenshot(screenshot.imageURL)">{{ screenshot.date }}</div>
						</div>
					</div>
				</div>
				<pagination-template
					#p="paginationApi"
					(pageChange)="p2 = $event"
					class="r102-pagination"
					*ngIf="screenShotsData.length > 8"
				>
					<ul class="pager">
						<li [class.disabled]="p.isFirstPage()" style="float: left" class="firstArrow">
							<a (click)="p.setCurrent(1)">
								<i class="fa fa-step-backward icons"></i>
							</a>
						</li>
						<li [class.disabled]="p.isFirstPage()" style="float: left">
							<a (click)="p.previous()" class="r103-leftarrow">
								<img class="arrow_image" src="../../../../../assets/partner-assets/default-r5/icons/left_arrow.png" />
							</a>
						</li>
						<li
							role="button"
							*ngFor="let page of p.pages"
							[class.current]="p.getCurrent() === page.value"
							class="pages"
							style="float: left"
						>
							<a
								(click)="p.setCurrent(page.value)"
								*ngIf="p.getCurrent() !== page.value"
								[class.primary-color-bg-on-hover]="p.getCurrent() !== page.value"
							>
								{{ page.label }}
							</a>
							<a *ngIf="p.getCurrent() === page.value" [class.primary-color-bg]="p.getCurrent() === page.value">
								{{ page.label }}
							</a>
						</li>
						<li [class.disabled]="p.isLastPage()" style="float: left">
							<a (click)="p.next()" class="r103-rightarrow">
								<img class="arrow_image" src="../../../../../assets/partner-assets/default-r5/icons/right_arrow.png" />
							</a>
						</li>
						<li [class.disabled]="p.isLastPage()" style="float: left" class="lastArrow">
							<a (click)="p.setCurrent(p.getLastPage())">
								<i class="fa fa-step-forward icons"></i>
							</a>
						</li>
					</ul>
				</pagination-template>
			</div>
			<ng-template #noScreenshotsBlock>
				<div class="no-screenshots-data" *ngIf="!isR6Enabled || !hasData">
					{{ nodatamessage }}
				</div>
				<div *ngIf="isR6Enabled" class="no-data-scrennshots">
					<div class="no-data-text">No Data Available</div>
				</div>
			</ng-template>
		</div>
	</div>
	<div class="clear"></div>
</div>
